module.exports = __webpack_public_path__ + "static/media/logos-harineratlanepantla.45c5ca94.png";